import React from "react";

import i18n from "../../../../constants/i18n";
import blockTypes from "../../../../constants/blockTypes";
import { addSecondsToDuration } from "../../../../helpers/blockDuration";
import Input from "../../../Input";
import DurationStepperInput from "../../../DurationStepperInput";

const SpeechModalView = ({
    blockType,
    errors,
    touched,
    hideModal,
    isVisible,
    setFieldValue,
    submitForm,
    values,
    isSubmitting
}) => {
    const isSlideshow = blockType === blockTypes.SLIDESHOW;
    const adjustDuration = seconds => {
        setFieldValue(
            "duration",
            addSecondsToDuration(values.duration, seconds)
        );
    };

    return (
        <div className={`modal ${isVisible ? "is-active" : ""}`}>
            <div className="modal-background" />
            <div className="modal-card">
                <header className="modal-card-head">
                    <h2 className="modal-card-title has-text-primary">
                        {isSlideshow
                            ? i18n.speechModal.slideshowTitle
                            : i18n.speechModal.title}
                    </h2>
                    <button
                        onClick={hideModal}
                        className="delete"
                        aria-label="close"
                    />
                </header>
                <section className="modal-card-body">
                    <Input
                        errors={errors}
                        touched={touched}
                        name="speaker"
                        label={
                            isSlideshow
                                ? i18n.speechModal.slideshowTitleField
                                : i18n.speechModal.speakerName
                        }
                        placeholder={
                            isSlideshow
                                ? i18n.speechModal.slideshowTitleField
                                : i18n.speechModal.speakerName
                        }
                    />
                    <DurationStepperInput
                        errors={errors}
                        touched={touched}
                        name="duration"
                        label={i18n.speechModal.durationField}
                        placeholder={i18n.speechModal.durationField}
                        onStepUp={() => adjustDuration(15)}
                        onStepDown={() => adjustDuration(-15)}
                    />
                </section>
                <footer className="modal-card-foot">
                    <button
                        onClick={submitForm}
                        disabled={isSubmitting}
                        className="button is-primary is-rounded"
                    >
                        {i18n.generic.add}
                    </button>
                </footer>
            </div>
        </div>
    );
};

export default SpeechModalView;
